import { Theme, ThemeUICSSObject } from 'theme-ui';
import customCheckbox from './customCheckbox';
import checkbox from './checkbox';
import dateInput from './dateInput';
import iconInput from './iconInput';
import input from './input';
import label from './label';
import radio from './radio';
import select from './select';
import selectMultiple from './selectMultiple';
import Switch from './switch';
import textarea from './textarea';
import deletableInput from './deletableInput';
/* IMPORT HERE */

const forms: (theme: Theme) => Record<string, ThemeUICSSObject> = (theme) => {
  return {
    checkbox,
    customCheckbox,
    dateInput,
    deletableInput,
    iconInput,
    input,
    label,
    radio,
    select,
    selectMultiple: selectMultiple(theme),
    switch: Switch,
    textarea,
    /* PREPEND HERE */
    'input[type="date"]': {
      variant: 'forms.input',
    },
  };
};

export default forms;
